import { z } from 'zod';
import { PermissionDefinitionSchema } from './permission.js';
import { TenantTypeEnum } from './tenant-type.js';

// ─── Tenant Permissions ─────────────────────────────────────────────
// Full permission set per tenant — returned by token exchange / refresh.
// Frontend derives navigable pages, page→tenant map, and PermissionViewModel
// from this single response.

/** A tenant with its full granted permission set */
export const TenantPermissionsSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    type: TenantTypeEnum,
    logoUrl: z.string().nullish(),
    permissions: z.array(PermissionDefinitionSchema),
});

export type TenantPermissions = z.infer<typeof TenantPermissionsSchema>;

// ─── Page State ─────────────────────────────────────────────────────
// Contracts for the page-state flow (GET /pages/:pageSlug/state).
// Page permissions use type=PAGE in the permissions table.
// Page slugs are bare strings (e.g. "opportunities", "identity-hub").

/** @deprecated Use TenantPermissionsSchema — kept for page-state endpoint backward compat */
export const TenantPagesSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    pages: z.array(z.string().min(1)),
});

/** @deprecated Use TenantPermissions */
export type TenantPages = z.infer<typeof TenantPagesSchema>;

/** Response shape for GET /pages/:pageSlug/state */
export const PageStateResponseSchema = z.object({
    tenants: z.array(TenantPagesSchema),
    pageState: z.record(z.string(), z.unknown()),
});

export type PageStateResponse = z.infer<typeof PageStateResponseSchema>;
